import { useState, useEffect } from 'react';
import { apiClient } from '@/lib/api-client';

interface Organization {
  orgId: string;
  name: string;
  logoUrl?: string;
  timezone?: string;
  language?: string;
  dateFormat?: string;
}

let cachedOrg: Organization | null = null;

export function useOrganization() {
  const [org, setOrg] = useState<Organization | null>(cachedOrg);

  useEffect(() => {
    if (cachedOrg) return;
    apiClient.get<Organization>('/organizations/me')
      .then((data) => {
        cachedOrg = data;
        setOrg(data);
      })
      .catch(() => {});
  }, []);

  const refresh = async () => {
    try {
      const data = await apiClient.get<Organization>('/organizations/me');
      cachedOrg = data;
      setOrg(data);
    } catch {}
  };

  return { org, refresh };
}
